var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationCredentials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5677 13.5417C21.2992 12.4902 21.7408 11.2645 21.848 9.98812C21.9553 8.71169 21.7244 7.42953 21.1786 6.2707C20.6328 5.11187 19.7914 4.11727 18.739 3.387C17.6866 2.65673 16.4605 2.21657 15.1839 2.11083C13.9074 2.00508 12.6255 2.23748 11.4673 2.78464C10.3091 3.33179 9.31548 4.17439 8.58645 5.22762C7.85743 6.28085 7.41871 7.50754 7.31447 8.78421C7.21023 10.0609 7.44414 11.3425 7.99266 12.5",
    stroke: "#176318",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11.6452C16.251 12.4691 15.4958 13.0202 14.6323 13.0202C13.3219 13.0202 12.2594 11.7504 12.2594 10.1848V8.56393C12.2594 6.99831 13.3219 5.72852 14.6323 5.72852C15.4958 5.72852 16.251 6.27956 16.6667 7.10352M10.9375 9.37435H14.8646",
    stroke: "#176318",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 14.584H5.61979C5.92604 14.584 6.22812 14.6527 6.50208 14.7861L8.62917 15.8152C8.90313 15.9475 9.20521 16.0163 9.5125 16.0163H10.5979C11.6479 16.0163 12.5 16.8402 12.5 17.8569C12.5 17.8986 12.4719 17.934 12.4312 17.9454L9.78437 18.6777C9.30943 18.8089 8.80299 18.763 8.35937 18.5486L6.08542 17.4486M12.5 17.1882L17.2844 15.7184C17.7009 15.5906 18.1471 15.5976 18.5594 15.7384C18.9717 15.8793 19.329 16.1468 19.5802 16.5027C19.9646 17.034 19.8083 17.7965 19.2479 18.1194L11.4198 22.6371C11.175 22.7787 10.904 22.869 10.6232 22.9025C10.3424 22.936 10.0577 22.912 9.78646 22.8319L3.125 20.8548",
    stroke: "#176318",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationCredentials);
export default __webpack_public_path__ + "static/media/OperationCredentials.91b8a2f04067105ee70b4c9e69797a5d.svg";
export { ForwardRef as ReactComponent };